import React from "react";
import styled from "styled-components";

const Title = styled.div`
  margin-top:12px;
  & hr {
    margin-top:4px;
  }
`;
const FormSectionTitle = ({ title }) => (
  <Title>
    {title}
  </Title>
);
export default FormSectionTitle;
